import axios from "axios";
import {
  findBrandByName,
  findModelByName
} from "@motorata/base-ui.data";

var sha1 = require('sha1');

const decode = async (vin: string) => {
  const sum = sha1(`${vin}|decode|bb739af9f271|0fe8c8e75f`).substring(0, 10);
    const { data } = await axios.get(`https://api.vindecoder.eu/3.2/bb739af9f271/${sum}/decode/${vin}.json`);
    const obj = {}
    data.decode.forEach(e => {
      obj[e.label] = e.value
    })

  console.log(obj)

  const finalObj = {}
  if(obj["Model Year"]){
    finalObj["year"] = obj["Model Year"]
  }else {
    throw new Error("Year was not found")
  }

  const brandObj = findBrandByName(obj["Make"])
  if(brandObj){
    finalObj["brand"] = brandObj[1]
  }else {
    throw new Error("Brand was not found")
  }

  const modelObj = findModelByName(obj["Make"], obj["Model"])
  if(modelObj){
    finalObj["model"] = modelObj[1]
  }else {
    throw new Error("Model was not found")
  }

  const fuelType1Obj = obj["Fuel Type - Primary"]
  const fuelType2Obj = obj["Fuel Type - Primary"]
  if(fuelType1Obj && ['Gasoline', 'Diesel', 'Electric'].includes(fuelType1Obj)){
    if(fuelType1Obj === "Diesel"){
      finalObj["fuelType"] = "diesel"
    }else if(fuelType1Obj === "Electric") {
      finalObj["fuelType"] = "electric"
    }else if (fuelType1Obj === "Gasoline"){
      if(fuelType2Obj === 'Electric'){
        finalObj["fuelType"] = "hybrid"
      }else {
        finalObj["fuelType"] = "petrol"
      }
    }
  }

  const gearBoxObj = obj["Transmission"]
  if(gearBoxObj && ['Automatic', 'Manual/Standard'].includes(gearBoxObj)){
    if(gearBoxObj === "Automatic"){
      finalObj["gearBox"] = "automatic"
    }else {
      finalObj["gearBox"] = "manual"
    }
  }

  const enginePowerObj = obj["Engine Power (HP)"]
  if(enginePowerObj){
    finalObj["enginePower"] = enginePowerObj
  }

  const engineCapacityObj = obj["Engine Displacement (ccm)"]
  if(engineCapacityObj){
    finalObj["engineCapacity"] = engineCapacityObj
  }

  return finalObj
}


export const VinDecoderService = {
  decode,
}
